import React from "react";
import { ColProps_5, ColProps_1 } from "@core/utils/ColProps";
import { Grid, Paper } from "@material-ui/core";
import useStyles from "./styles";
import { MarketProvider } from "@context/MarketContext";
import CurrencySelect from "@features/Market/MainComponents/MarketHeader/CurrencySelect";
import TradeVolume from "@features/Market/MainComponents/MarketHeader/TradeVolume";
import Warnings from "@features/Market/MainComponents/MarketHeader/Warnings";
import Settings from "@features/Market/MainComponents/MarketHeader/Settings";
import OrderBook from "@features/Market/MainComponents/OrderBook";
import MarketOrder from "@features/Market/MainComponents/MarketOrder";
import MarketChart from "@features/Market/MainComponents/MarketChart";
import MarketTable from "@features/Market/MainComponents/MarketTable";

const Template1 = () => {
  const classes = useStyles();
  return (
    <MarketProvider>
      <Grid container direction="column" spacing={5}>
        <Grid
          item
          container
          {...ColProps_1}
          justify="space-between"
          alignItems="center"
        >
          <Grid item {...ColProps_5}>
            <CurrencySelect />
          </Grid>
          <Grid
            item
            container
            direction="row"
            {...ColProps_5}
            spacing={4}
            justify="space-between"
          >
            <Grid item className={classes.TradeVolume}>
              <TradeVolume />
            </Grid>
            <Grid item>
              <Warnings />
            </Grid>
            <Grid item>
              <Settings />
            </Grid>
          </Grid>
        </Grid>

        <Grid item container justify="space-between" spacing={6}>
          <Grid
            item
            {...ColProps_5}
            container
            direction="column"
            className={classes.rightContainer}
          >
            <Grid item {...ColProps_1} className={classes.marginBottom}>
              <Paper elevation={0} className={classes.orderBook}>
                <OrderBook />
              </Paper>
            </Grid>
            <Grid item {...ColProps_1}>
              <Paper elevation={0} className={classes.order}>
                <MarketOrder />
              </Paper>
            </Grid>
          </Grid>
          <Grid
            item
            {...ColProps_5}
            container
            direction="column"
            className={classes.adjustSpace}
          >
            <Grid item {...ColProps_1} className={classes.marginBottom}>
              <Paper elevation={0} className={classes.chart}>
                <MarketChart />
              </Paper>
            </Grid>
            <Grid item {...ColProps_1}>
              <Paper elevation={0} className={classes.table}>
                <MarketTable
                  recentMarket={true}
                  height="145px"
                  emptySize="small"
                />
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </MarketProvider>
  );
};

export default Template1;
